<script setup>
import { computed } from 'vue'
import ContinueButton from '../molecules/ContinueButton.vue';

const { title, text, imgName } = defineProps(['title', 'text', 'imgName'])

const imageSrc = computed(() => {
  return new URL(`../../assets/images/${imgName}.png`, import.meta.url).href
})
</script>

<template>
  <div class="component-container">
    <div class="component-card">
      <div class="img-container">
        <img :src="imageSrc" :alt="imgName" />
      </div>
      <div class="texts">
        <p class="heading-5">{{ title }}</p>
        <p class="p-md text">{{ text }}</p>
      </div>
    </div>
    <ContinueButton @click="$emit('cta')"/>
  </div>
</template>

<style scoped>

.text {
  color: var(--neutrals-700);
}

.component-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: left;
}

.texts {
  padding-left: 20px;
  padding-right: 20px;
  text-align: left;
}

.img-container {
  height: 250px;
}

img {
  width: auto;
  height: 100%;
  max-width: 400px;
}

button {
  display: inline-block;
}

.heading-5 {
  margin-top: 24px;
  margin-bottom: 16px;
}

@media screen and (max-width: 850px) {
  .img-container {
    height: 200px;
  }

  .component-card {
  }
}
</style>
